module.exports = __webpack_public_path__ + "static/media/access@2x.c8c00e85.png";